import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import throttle from 'lodash/throttle';

import isLoggedIn, {isGM, isSA} from '../../../utils/auth';
import {formatDiamondTitle, formatNumber, formatFluorescence, formatCarat, formatShape, formatPrice, formatCost, formatCut, formatColor, formatClarity, formatSymmetry, formatPolish, formatLocation, getLocationId, formatMeasurements, formatTable, formatDepth, formatPddSpiff} from '../../../utils/formatting';

import * as holdConst from '../../../constants/hold';
import * as api from '../../../constants/api';

import {DiamondSourceBannerContainer} from '../common/DiamondSourceBanner';

import RhinoModal from '../../common/modal/RhinoModal';
import RhinoSelect from '../../common/inputs/RhinoSelect';
import RhinoLoading from '../common/RhinoLoading';

import * as authActionCreators from '../../../actions/auth';
import * as commonActionCreators from '../../../actions/common';
import * as diamondsActionCreators from '../../../actions/diamonds';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, diamondsActionCreators, leadsActionCreators, messagesActionCreators, usersActionCreators);

class Results extends React.Component {


	constructor(props) {
		super(props);

    let sortByOptions = [
      { display: 'Sort By', value: '' },
      { display: 'Price', value: 'price' },
      { display: 'Carat', value: 'carat' },
      { display: 'Color', value: 'color' },
      { display: 'Clarity', value: 'clarity' },
      { display: 'Location', value: 'location' },
    ];

    let actionsOptions = [
      { display: 'Actions', value: '' },
      { display: 'Show Only Selected', value: 'showOnly' },
      { display: 'Add to My Profile', value: 'profile' },
      { display: 'Share All', value: 'share' },
      { display: 'Uncheck All', value: 'uncheck' },
    ];

    this.CARAT_MIN = 0;
    this.CARAT_MAX = 20;
    this.PRICE_MIN = 0;
    this.PRICE_MAX = 1000000;
    this.COST_MIN = 0;
    this.COST_MAX = 1000000;
    this.TABLE_MIN = 0;
    this.TABLE_MAX = 100;

    this.LENGTH_MIN = 0;
    this.LENGTH_MAX = 100;
    this.WIDTH_MIN = 0;
    this.WIDTH_MAX = 100;
    this.HEIGHT_MIN = 0;
    this.HEIGHT_MAX = 100;

    this.DEPTH_MIN = 0;
    this.DEPTH_MAX = 100;
    this.RATIO_MIN = 0;
    this.RATIO_MAX = 5;

    this.cutOptions = [ 'EX', 'VG' ];
    this.colorOptions = [ 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M' ];
    this.clarityOptions = [ 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2' ];
    this.symOptions = [ 'EX', 'VG', 'G', 'Fair' ];
    this.polishOptions = [ 'EX', 'VG', 'G', 'Fair' ];
    this.flourOptions = [ 'Very Strong', 'Strong', 'Medium', 'Faint', 'None' ];

    this.state = {
      selectedDiamonds: this.props.diamonds.selectedList,
      expandedIndividualShares: [],
      showOnlySelected: false,

      sortByOpen: false,
      sortByDisplay: (this.props.diamonds.source === 'store' && this.props.diamonds.diamondFilter?.sort !== 'price') ? 'Purple' : 'Price',
      sortByValue: null,

      sortByExtensionOpen: false,
      sortByExtensionDisplay: null,
      sortByExtensionValue: null,

      locations: this.props.diamonds.diamondFilter.locations ? this.props.diamonds.diamondFilter.locations : '',

      actionsOpen: false,
      shareAllOpen: false,

      transferModalOpen: false,
      transferMessage: '',
      transferName: '',
      transferApptDate: '',
      transferApptTime: '',
      transferBudget: '',

      transferApptDateError: '',

      holdModalOpen: false,
      holdMessage: '',

      shareModalOpen: false,

      currentPage: 1,
      defaultResults: 100,
      lastPage: false,
      requestPending: this.props.diamonds.diamondResults == null,

      locationData: null,

      resultsBlocked: false,
      windowWidth: window.innerWidth,
    }

    // Load diamonds based on filters
    if(this.props.diamonds.diamondResults == null) {


      if(this.props.diamonds.source === 'online') {

        // Online Diamonds

        this.props.fetchOnlineDiamonds(this.setOnlineDiamondFilters(this.props.diamonds.diamondFilter), 1)
        .then((respData) => {
          if(respData === null || !respData.Data) {
            this.setState({ resultsBlocked: true });
          } else {

            this.setState({ 
              requestPending: false,
              lastPage: parseInt(respData.Data.count) < this.state.defaultResults,
            });

            // DO NEXT: add last page to other fetch diamond results

            this.props.diamondsSave(this.mapOnlineDiamondResp(respData.Data.data), respData.Data.count);
          }
        })
        // .catch((errorResp) => {
        //   this.setState({ requestPending: false });
        //   console.error(errorResp);
        // }); 

      } else if(this.props.diamonds.source === 'rapnet') {

        // Rapnet Diamonds

        this.props.fetchRapnetDiamonds(this.setRapnetDiamondFilters(this.props.diamonds.diamondFilter), 1)
        .then((respData) => {
          if(respData === null) {
            this.setState({ resultsBlocked: true });
          } else {
            this.setState({ 
              requestPending: false,
              lastPage: parseInt(respData.search_results.diamonds_returned) < 50,
            });
            this.props.diamondsSave(this.mapRapnetDiamondResp(respData.diamonds), respData.search_results.total_diamonds_found);
          }
        })
        // .catch((errorResp) => {
        //   this.setState({ requestPending: false });
        //   console.error(errorResp);
        // }); 
      } else if(this.props.diamonds.source === 'lab') {

        // Lab-created Diamonds

        this.props.fetchDiamonds(this.setLabDiamondFilters(this.props.diamonds.diamondFilter), 1)
        .then((respData) => {
          if(respData === null) {
            this.setState({ resultsBlocked: true });
          } else {
            this.setState({ 
              requestPending: false,
              lastPage: parseInt(respData.count) < this.state.defaultResults,
            });
            this.props.diamondsSave(respData.diamonds, respData.count);
          }
        })
        // .catch((errorResp) => {
        //   this.setState({ requestPending: false });
        //   console.error(errorResp);
        // }); 
      } else {

        // App (ASC) Diamonds

        this.props.fetchDiamonds(this.props.diamonds.diamondFilter, 1)
        .then((respData) => {
          if(respData === null) {
            this.setState({ resultsBlocked: true });
          } else {

            this.setState({ 
              requestPending: false,
              lastPage: parseInt(respData.count) < this.state.defaultResults,
            });

            // DO NEXT: add last page to other fetch diamond results

            this.props.diamondsSave(respData.diamonds, respData.count);
          }
        })
        // .catch((errorResp) => {
        //   this.setState({ requestPending: false });
        //   console.error(errorResp);
        // }); 
      }
    }

    // Load diamonds based on filters
    if(this.state.locationData == null) {

      this.props.fetchLocationData(this.props.diamonds.diamondFilter)
      .then((respData) => {
        this.setState({ locationData: respData.locations });
      })
      // .catch((errorResp) => {
      //   this.setState({ requestPending: false });
      //   console.error(errorResp);
      // });      
    }

    // Bind event listeners
    this.checkSortBy = this.checkSortBy.bind(this);
    this.checkSortByExtension = this.checkSortByExtension.bind(this);
    this.checkActions = this.checkActions.bind(this);
    this.getScrollPercentage = this.getScrollPercentage.bind(this);
    this.setWindowWidth = this.setWindowWidth.bind(this);

    this.scrollThrottle = throttle(this.getScrollPercentage, 500, { 'leading': true, 'trailing': false });
	}

  componentDidMount() {

    let intId = setInterval(this.getScrollPercentage, 1000);

    if(this.props.diamonds.lastResultsPosition) {
      this.props.commonScrollTo(this.props.diamonds.lastResultsPosition);
      this.props.diamondsSetLastPosition(0);
    }
  }

  componentWillMount() {
    document.addEventListener('click', this.checkSortBy, false);
    document.addEventListener('click', this.checkSortByExtension, false);
    document.addEventListener('click', this.checkActions, false);
    window.addEventListener('scroll', this.getScrollPercentage, false);
    window.addEventListener('resize', this.setWindowWidth, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkSortBy, false);
    document.removeEventListener('click', this.checkSortByExtension, false);
    document.removeEventListener('click', this.checkActions, false);
    window.removeEventListener('scroll', this.scrollThrottle, false);
    window.removeEventListener('resize', this.setWindowWidth, false);
  }

  setWindowWidth() {
    this.setState({ windowWidth: window.innerWidth });
  }

  createList(optionsArray) {

    let first = true;
    let optionList = '';

    if(optionsArray.length === 0) {
      return 'All';
    }

    for(let i = 0; i < optionsArray.length; i++) {
      if(first) {
        optionList = optionsArray[i];
      } else {
        optionList += ',' + optionsArray[i];
      }
      first = false;
    }
    return optionList;
  }

  getMaxValue(filterValues, filterOptions) {

    if(filterValues == 'All') {
      return this.getMaxPossible(filterOptions);
    }

    for(let i = 0; i < filterOptions.length; i++) {
      if(filterValues.includes(filterOptions[i])) {
        return filterOptions[i];
      }
    }
    return '';
  }

  getMaxPossible(filterOptions) {
    return filterOptions[0];
  }

  getMinValue(filterValues, filterOptions) {

    if(filterValues == 'All') {
      return this.getMinPossible(filterOptions);
    }

    for(let i = filterOptions.length - 1; i >= 0; i--) {
      if(filterValues.includes(filterOptions[i])) {
        return filterOptions[i];
      }
    }
    return '';
  }

  getMinPossible(filterOptions) {
    return filterOptions[filterOptions.length - 1];
  }

  setOnlineDiamondFilters() {

    const diamondKeys = [
      "shape",
      "origin",
      "caratWeightMin",
      "caratWeightMax",
      "color",
      "clarity",
      "cut",
      "polish",
      "symmetry",
      "fluorescence",
      "lengthMin",
      "lengthMax",
      "widthMin",
      "widthMax",
      "depthMin",
      "depthMax",
      "tableMin",
      "tableMax",
      "retailPriceMin",
      "retailPriceMax",
      "sortBy",
      "searchTerm",
      "costMin",
      "costMax",

      "ratioMin",
      "ratioMax",
    ];

    const reqFilters = {
      status: 'Available',
      limit: '100',
      isNaturalDiamond: this.props.diamonds.diamondFilter.isNaturalDiamond,
    };

    for(const key of diamondKeys) {
      switch(key) {
        case 'shape':
          if(this.props.diamonds.diamondFilter.shape && this.props.diamonds.diamondFilter.shape !== 'All') {
            reqFilters[key] = this.props.diamonds.diamondFilter.shape ? this.mapOnlineShapes(this.props.diamonds.diamondFilter.shape) : '';
          }
          break;
        case 'caratWeightMin':
          reqFilters[key] = this.props.diamonds.diamondFilter.carat_min ? this.props.diamonds.diamondFilter.carat_min : this.CARAT_MIN;
          break;
        case 'caratWeightMax':
          reqFilters[key] = this.props.diamonds.diamondFilter.carat_max ? this.props.diamonds.diamondFilter.carat_max : this.CARAT_MAX;
          break;
        case 'color':
          if(this.props.diamonds.diamondFilter.color && this.props.diamonds.diamondFilter.color !== 'All') {
            reqFilters[key] = this.props.diamonds.diamondFilter.color ? this.props.diamonds.diamondFilter.color : '';
          }
          break;
        case 'clarity':
          if(this.props.diamonds.diamondFilter.clarity && this.props.diamonds.diamondFilter.clarity !== 'All') {
            reqFilters[key] = this.props.diamonds.diamondFilter.clarity ? this.props.diamonds.diamondFilter.clarity : '';
          }
          // reqFilters[key] = this.props.diamonds.diamondFilter.clarity ? this.getMinValue(this.props.diamonds.diamondFilter.clarity, this.clarityOptions) : this.getMinPossible(this.clarityOptions);
          break;
        // case 'clarityMax':
        //   reqFilters[key] = this.props.diamonds.diamondFilter.clarity ? this.getMaxValue(this.props.diamonds.diamondFilter.clarity, this.clarityOptions) : this.getMaxPossible(this.clarityOptions);
        //   break;
        case 'cut':
          // reqFilters[key] = this.props.diamonds.diamondFilter.cut ? this.getMinValue(this.props.diamonds.diamondFilter.cut, this.cutOptions) : this.getMinPossible(this.cutOptions);
          reqFilters[key] = this.props.diamonds.diamondFilter.cut && this.props.diamonds.diamondFilter.cut !== 'All' ? this.props.diamonds.diamondFilter.cut : '';
          break;
        // case 'cutMax':
        //   reqFilters[key] = this.props.diamonds.diamondFilter.cut ? this.getMaxValue(this.props.diamonds.diamondFilter.cut, this.cutOptions) : this.getMaxPossible(this.cutOptions);
        //   break;
        case 'polish':
          // reqFilters[key] = this.props.diamonds.diamondFilter.polish ? this.getMinValue(this.props.diamonds.diamondFilter.polish, this.polishOptions) : this.getMinPossible(this.polishOptions);
          reqFilters[key] = this.props.diamonds.diamondFilter.polish && this.props.diamonds.diamondFilter.polish !== 'All' ? this.props.diamonds.diamondFilter.polish : '';
          break;
        // case 'polMax':
        //   reqFilters[key] = this.props.diamonds.diamondFilter.polish ? this.getMaxValue(this.props.diamonds.diamondFilter.polish, this.polishOptions) : this.getMaxPossible(this.polishOptions);
        //   break;
        case 'symmetry':
          // reqFilters[key] = this.props.diamonds.diamondFilter.symmetry ? this.getMinValue(this.props.diamonds.diamondFilter.symmetry, this.symOptions) : this.getMinPossible(this.symOptions);
          reqFilters[key] = this.props.diamonds.diamondFilter.symmetry && this.props.diamonds.diamondFilter.symmetry !== 'All' ? this.props.diamonds.diamondFilter.symmetry : '';
          break;
        // case 'symMax':
        //   reqFilters[key] = this.props.diamonds.diamondFilter.symmetry ? this.getMaxValue(this.props.diamonds.diamondFilter.symmetry, this.symOptions) : this.getMaxPossible(this.symOptions);
        //   break;
        case 'fluorescence':
          // reqFilters[key] = this.props.diamonds.diamondFilter.flourescence ? this.getMinValue(this.props.diamonds.diamondFilter.flourescence, this.flourOptions) : this.getMinPossible(this.flourOptions);
          reqFilters[key] = this.props.diamonds.diamondFilter.flourescence && this.props.diamonds.diamondFilter.flourescence !== 'All' ? this.props.diamonds.diamondFilter.flourescence : '';
          break;
        // case 'fluorMax':
        //   reqFilters[key] = this.props.diamonds.diamondFilter.flourescence ? this.getMaxValue(this.props.diamonds.diamondFilter.flourescence, this.flourOptions) : this.getMaxPossible(this.flourOptions);
        //   break;
        case 'depthMin':
          reqFilters[key] = this.props.diamonds.diamondFilter.depth_min ? this.props.diamonds.diamondFilter.depth_min : this.HEIGHT_MIN;
          break;
        case 'depthMax':
          reqFilters[key] = this.props.diamonds.diamondFilter.depth_max ? this.props.diamonds.diamondFilter.depth_max : this.HEIGHT_MAX;
          break;
        case 'lengthMin':
          reqFilters[key] = this.props.diamonds.diamondFilter.length_min ? this.props.diamonds.diamondFilter.length_min : this.LENGTH_MIN;
          break;
        case 'lengthMax':
          reqFilters[key] = this.props.diamonds.diamondFilter.length_max ? this.props.diamonds.diamondFilter.length_max : this.LENGTH_MAX;
          break;
        case 'widthMin':
          reqFilters[key] = this.props.diamonds.diamondFilter.width_min ? this.props.diamonds.diamondFilter.width_min : this.WIDTH_MIN;
          break;
        case 'widthMax':
          reqFilters[key] = this.props.diamonds.diamondFilter.width_max ? this.props.diamonds.diamondFilter.width_max : this.WIDTH_MAX;
          break;
        case 'tableMin':
          reqFilters[key] = this.props.diamonds.diamondFilter.table_min ? this.props.diamonds.diamondFilter.table_min : this.TABLE_MIN;
          break;
        case 'tableMax':
          reqFilters[key] = this.props.diamonds.diamondFilter.table_max ? this.props.diamonds.diamondFilter.table_max : this.TABLE_MAX;
          break;
        case 'retailPriceMin':
          reqFilters[key] = this.props.diamonds.diamondFilter.price_min ? this.props.diamonds.diamondFilter.price_min : this.PRICE_MIN;
          break;
        case 'retailPriceMax':
          reqFilters[key] = this.props.diamonds.diamondFilter.price_max ? this.props.diamonds.diamondFilter.price_max : this.PRICE_MAX;
          break;
        case 'costMin':
          reqFilters[key] = this.props.diamonds.diamondFilter.cost_min ? this.props.diamonds.diamondFilter.cost_min : this.COST_MIN;
          break;
        case 'costMax':
          reqFilters[key] = this.props.diamonds.diamondFilter.cost_max ? this.props.diamonds.diamondFilter.cost_max : this.COST_MAX;
          break;
        case 'ratioMin':
          reqFilters[key] = this.props.diamonds.diamondFilter.ratio_min ? this.props.diamonds.diamondFilter.ratio_min : this.RATIO_MIN;
          break;
        case 'ratioMax':
          reqFilters[key] = this.props.diamonds.diamondFilter.ratio_max ? this.props.diamonds.diamondFilter.ratio_max : this.RATIO_MAX;
          break;
        case 'sortBy':
          if(this.props.diamonds.diamondFilter.sort) {
            reqFilters[key] = this.props.diamonds.diamondFilter.sort;
            reqFilters['sortOrder'] = this.props.diamonds.diamondFilter.sort === 'color' ? 'desc' : 'asc';
          } else {
            reqFilters[key] = 'price';
            reqFilters['sortOrder'] = 'asc';
          }
          break;
        case 'searchTerm':
          if(this.props.diamonds.diamondFilter.searchTerm) {
            reqFilters['search'] = this.props.diamonds.diamondFilter.searchTerm;
          }
        default:
          break;
      }
    }
    return reqFilters;
  }

  mapRapnetShapes(shapeList) {
    const shapeMap = {
      ROUNDS: 'Round',
      OVALS: 'Oval',
      EMERALD: 'Emerald',
      PEAR: 'Pear',
      CUSHION: 'Cushion',
      PRINCESS: 'Princess',
      RADIANT: 'Radiant',
      MARQUISE: 'Marquise',
      ASCHER: 'Asscher',
      HEART: 'Heart',
    }

    const shapeResp = [];
    for(const key in shapeMap) {
      if(shapeList.includes(key)) {
        shapeResp.push(shapeMap[key]);
      }
    }
    return shapeResp;
  }

  mapOnlineShapes(shapeList) {
    const shapeMap = {
      ROUNDS: 'Round',
      OVALS: 'Oval',
      EMERALD: 'Emerald',
      PEAR: 'Pear',
      CUSHION: 'Cushion',
      PRINCESS: 'Princess',
      RADIANT: 'Radiant',
      MARQUISE: 'Marquise',
      ASCHER: 'Asscher',
      HEART: 'Heart',
    }

    const shapeResp = [];
    for(const key in shapeMap) {
      if(shapeList.includes(key)) {
        shapeResp.push(shapeMap[key]);
      }
    }
    return shapeResp.join();
  }

  mapRapnetCut(cutValue) {
    const cutMap = {
      EX: 'Excellent',
      VG: 'Very Good',
    }
    return cutMap[cutValue] ? cutMap[cutValue] : '';
  }

  mapRapnetPolish(polishValue) {
    const polishMap = {
      EX: 'Excellent',
      VG: 'Very Good',
      G: 'Good',
      Fair: 'Fair',
    }
    return polishMap[polishValue] ? polishMap[polishValue] : '';
  }

  setRapnetDiamondFilters() {

    const diamondKeys = [
      "shapes",
      "size_from",
      "size_to",
      "color_from",
      "color_to",

      "clarity_from",
      "clarity_to",

      "cut_from",
      "cut_to",

      "polish_from",
      "polish_to",
      "symmetry_from",
      "symmetry_to",
      "fluorescence_intensities",
      "depth_percent_from",
      "depth_percent_to",
      "table_percent_from",
      "table_percent_to",
      "price_total_from",
      "price_total_to",

      "sort_by",
      "sort_direction",
    ];

    const reqFilters = {
      lab: 'GIA', 
    };
    for(const key of diamondKeys) {
    
      switch(key) {
        case 'shapes':
          if(this.props.diamonds.diamondFilter.shape && this.props.diamonds.diamondFilter.shape !== 'All') {
            reqFilters[key] = this.props.diamonds.diamondFilter.shape ? this.mapRapnetShapes(this.props.diamonds.diamondFilter.shape) : '';
          }
          break;
        case 'size_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.carat_min ? parseFloat(this.props.diamonds.diamondFilter.carat_min) : this.CARAT_MIN;
          break;
        case 'size_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.carat_max ? parseFloat(this.props.diamonds.diamondFilter.carat_max) : this.CARAT_MAX;
          break;
        case 'color_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.color ? this.getMinValue(this.props.diamonds.diamondFilter.color, this.colorOptions) : this.getMinPossible(this.colorOptions);
          break;
        case 'color_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.color ? this.getMaxValue(this.props.diamonds.diamondFilter.color, this.colorOptions) : this.getMaxPossible(this.colorOptions);
          break;
        case 'clarity_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.clarity ? this.getMinValue(this.props.diamonds.diamondFilter.clarity, this.clarityOptions) : this.getMinPossible(this.clarityOptions);
          break;
        case 'clarity_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.clarity ? this.getMaxValue(this.props.diamonds.diamondFilter.clarity, this.clarityOptions) : this.getMaxPossible(this.clarityOptions);
          break;
        case 'cut_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.cut ? this.mapRapnetCut(this.getMinValue(this.props.diamonds.diamondFilter.cut, this.cutOptions)) : this.mapRapnetCut(this.getMinPossible(this.cutOptions));
          break;
        case 'cut_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.cut ? this.mapRapnetCut(this.getMaxValue(this.props.diamonds.diamondFilter.cut, this.cutOptions)) : this.mapRapnetCut(this.getMaxPossible(this.cutOptions));
          break;
        case 'polish_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.polish ? this.mapRapnetPolish(this.getMinValue(this.props.diamonds.diamondFilter.polish, this.polishOptions)) : this.mapRapnetPolish(this.getMinPossible(this.polishOptions));
          break;
        case 'polish_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.polish ? this.mapRapnetPolish(this.getMaxValue(this.props.diamonds.diamondFilter.polish, this.polishOptions)) : this.mapRapnetPolish(this.getMaxPossible(this.polishOptions));
          break;
        case 'symmetry_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.symmetry ? this.mapRapnetPolish(this.getMinValue(this.props.diamonds.diamondFilter.symmetry, this.symOptions)) : this.mapRapnetPolish(this.getMinPossible(this.symOptions));
          break;
        case 'symmetry_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.symmetry ? this.mapRapnetPolish(this.getMaxValue(this.props.diamonds.diamondFilter.symmetry, this.symOptions)) : this.mapRapnetPolish(this.getMaxPossible(this.symOptions));
          break;
        case 'fluorescence_intensities':
          if(this.props.diamonds.diamondFilter.flourescence && this.props.diamonds.diamondFilter.flourescence !== 'All') {
            reqFilters[key] = this.props.diamonds.diamondFilter.flourescence ? this.props.diamonds.diamondFilter.flourescence.split(',') : '';
          }
          break;
        case 'depth_percent_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.depth_min ? this.props.diamonds.diamondFilter.depth_min : this.DEPTH_MIN;
          break;
        case 'depth_percent_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.depth_max ? this.props.diamonds.diamondFilter.depth_max : this.DEPTH_MAX;
          break;
        case 'table_percent_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.table_min ? this.props.diamonds.diamondFilter.table_min : this.TABLE_MIN;
          break;
        case 'table_percent_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.table_max ? this.props.diamonds.diamondFilter.table_max : this.TABLE_MAX;
          break;
        case 'price_total_from':
          reqFilters[key] = this.props.diamonds.diamondFilter.price_min ? parseInt(this.props.diamonds.diamondFilter.price_min) : this.PRICE_MIN;
          break;
        case 'price_total_to':
          reqFilters[key] = this.props.diamonds.diamondFilter.price_max ? parseInt(this.props.diamonds.diamondFilter.price_max) : this.PRICE_MAX;
          break;
        case 'sort_by':
          if(this.props.diamonds.diamondFilter.sort_by) {
            reqFilters[key] = this.props.diamonds.diamondFilter.sort_by;
          } else {
            reqFilters[key] = 'Price';
          }
          break;
        case 'sort_direction':
          if(this.props.diamonds.diamondFilter.sort_direction) {
            reqFilters[key] = this.props.diamonds.diamondFilter.sort_direction;
          }
          break;
        default:
          break;
      }
    }
    return reqFilters;
  }

  setLabDiamondFilters(diamondFilters) {
    return Object.assign({}, diamondFilters, { lcd: true });
  }

  checkSortBy(evt) {

    if(this.state.sortByOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.sortByMenuBody || targetElement == this.sortByLabel || targetElement == this.sortByArrow || targetElement == this.sortByDisplay) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ sortByOpen: false });
    }
  }

  checkSortByExtension(evt) {
    
    if(this.state.sortByExtensionOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.sortByExtensionMenuBody || targetElement == this.sortByLabel || targetElement == this.sortByArrow || targetElement == this.sortByExtensionDisplay) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ sortByExtensionOpen: false });
    }
  }

  checkActions(evt) {
    
    if(this.state.actionsOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.actionsMenuBody || targetElement == this.actionsLabel || targetElement == this.actionsArrow) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.setState({ actionsOpen: false });
    }
  }

  getScrollPercentage() {
    if(this.resultsWrapper) {
      let percent = this.props.common.currentScrollTop / (this.resultsWrapper.offsetHeight);
      if(percent > 0.8) {
        this.appendSearch();
      }
    }
  }

  mapOnlineDiamondResp(respArray) {

    // key: online resp key
    // value: app resp key
    const mapKey = {
      // id: 'web_item',
      caratWeight: 'carat_weight',
      certUrl: 'certificate', 
      certNo: 'gia_number', 
      stockNo: 'web_item', 
      measurement: 'measurements',
      fluorescence: 'flourescence',
    }

    const additions = {
      in_wallet: false,
      is_owned: null,
      is_available: true,
      case_location: '',
      lab: 'GIA',
      days_to_sell: null, 
    }

    const mappedArray = [];
    for(const respItem of respArray) {

      const mappings = {};
      for(const key in mapKey) {
        mappings[mapKey[key]] = respItem[key];
      }

      mappedArray.push(Object.assign({}, respItem, mappings, additions));
    }
    return mappedArray;
  }

  mapRapnetDiamondResp(respArray) {

    // // key: rapnet resp key
    // // value: app resp key
    const mapKey = {
      cert_num: 'gia_number', 
      stock_num: 'web_item', 
      diamond_id: 'id',
      size: 'carat_weight', 
      image_file_url: 'image',
      total_sales_price: 'price',
      depth_percent: 'depth', 
      table_percent: 'table',
      meas_length: 'length', 
      meas_width: 'width', 
      meas_depth: 'height', 
      fluor_intensity: 'flourescence', 
    }

    const additions = {
      in_wallet: false,
      is_owned: null,
      is_available: true,
      case_location: '',
      lab: 'GIA',
      days_to_sell: null, 
    }

    const mappedArray = [];
    for(const respItem of respArray) {

      const mappings = {};
      for(const key in mapKey) {
        mappings[mapKey[key]] = respItem[key];
      }

      // Add Measurements;
      mappings['measurements'] = `${respItem['meas_length']} x ${respItem['meas_width']} x ${respItem['meas_depth']}`;

      mappedArray.push(Object.assign({}, respItem, mappings, additions));
    }
    return mappedArray;
  }

  resetSearch() {
    this.props.diamondsSave(null);
    this.setState({
      requestPending: true,
      resultsBlocked: false,
    }, () => {
      setTimeout(() => {
        if(this.props.diamonds.source === 'online') {

          this.props.fetchOnlineDiamonds(this.setOnlineDiamondFilters(this.props.diamonds.diamondFilter), 1)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.count) < this.state.defaultResults,
              });
              this.props.diamondsSave(this.mapOnlineDiamondResp(respData.Data.data), respData.Data.count);
            }          
          })

        } else if(this.props.diamonds.source === 'rapnet') {

          this.props.fetchRapnetDiamonds(this.setRapnetDiamondFilters(this.props.diamonds.diamondFilter), 1)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.search_results.diamonds_returned) < 50,
              });
              this.props.diamondsSave(this.mapRapnetDiamondResp(respData.diamonds), respData.search_results.total_diamonds_found);
            }        
          })

        } else if(this.props.diamonds.source === 'lab') {

          this.props.fetchDiamonds(this.setLabDiamondFilters(this.props.diamonds.diamondFilter), 1)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.count) < this.state.defaultResults,
              });
              this.props.diamondsSave(respData.diamonds, respData.count);
            }          
          })

        } else {

          this.props.fetchDiamonds(this.props.diamonds.diamondFilter, 1)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.count) < this.state.defaultResults,
              });
              this.props.diamondsSave(respData.diamonds, respData.count);
            }          
          })

        }
      }, 50);
    });
  }

  appendSearch() {
    if(!this.state.requestPending && !this.state.lastPage) {
      this.setState({
        requestPending: true,
        currentPage: this.state.currentPage + 1,
      }, () => {
        if(this.props.diamonds.source === 'online') {

          this.props.fetchOnlineDiamonds(this.setOnlineDiamondFilters(this.props.diamonds.diamondFilter), this.state.currentPage)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.count) < this.state.defaultResults,
              });

              let existingDiamonds = this.cloneArray(this.props.diamonds.diamondResults);
              let appendedDiamonds = existingDiamonds.concat(this.mapOnlineDiamondResp(respData.Data.data));

              this.props.diamondsSave(appendedDiamonds, respData.count);
            }
          });

        } else if(this.props.diamonds.source === 'rapnet') {

          this.props.fetchRapnetDiamonds(this.setRapnetDiamondFilters(this.props.diamonds.diamondFilter), this.state.currentPage)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.search_results.diamonds_returned) < 50,
              });

              let existingDiamonds = this.cloneArray(this.props.diamonds.diamondResults);
              let appendedDiamonds = existingDiamonds.concat(this.mapRapnetDiamondResp(respData.diamonds));

              this.props.diamondsSave(appendedDiamonds, respData.search_results.total_diamonds_found);
            }

            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              
            }
          });
        } else if(this.props.diamonds.source === 'lab') {

          this.props.fetchDiamonds(this.setLabDiamondFilters(this.props.diamonds.diamondFilter), this.state.currentPage)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.count) < this.state.defaultResults,
              });

              let existingDiamonds = this.cloneArray(this.props.diamonds.diamondResults);
              let appendedDiamonds = existingDiamonds.concat(respData.diamonds);

              this.props.diamondsSave(appendedDiamonds, respData.count);
            }
          });

        } else {

          this.props.fetchDiamonds(this.props.diamonds.diamondFilter, this.state.currentPage)
          .then((respData) => {
            if(respData === null) {
              this.setState({ resultsBlocked: true });
            } else {
              this.setState({ 
                requestPending: false,
                lastPage: parseInt(respData.count) < this.state.defaultResults,
              });

              let existingDiamonds = this.cloneArray(this.props.diamonds.diamondResults);
              let appendedDiamonds = existingDiamonds.concat(respData.diamonds);

              this.props.diamondsSave(appendedDiamonds, respData.count);
            }
          });
        }
      });
    }
  }

  addSort(value) {

    let currentSort = this.props.diamonds.diamondFilter.sort;

    if(!currentSort) {
      currentSort = '';
    }

    let sortParam = '';

    if(value == 'Purple') {
      sortParam = '-is_pdd';
    } else if(value == 'Price') {
      if(this.props.diamonds.source === 'online') {
        sortParam = 'price';
      } else if(this.props.diamonds.source === 'rapnet') {
        sortParam = 'Price';
      } else {
        sortParam = 'price';
      }
    } else if(value == 'Cost') {
      sortParam = 'cost';
    } else if(value == 'Carat') {
      if(this.props.diamonds.source === 'online') {
        sortParam = 'carat';
      } else if(this.props.diamonds.source === 'rapnet') {
        sortParam = 'Size';
      } else {
        sortParam = 'carat_weight';
      }
    } else if(value == 'Color') {
      if(this.props.diamonds.source === 'online') {
        sortParam = 'color';
      } else if(this.props.diamonds.source === 'rapnet') {
        sortParam = 'Color';
      } else {
        sortParam = 'color';
      }
    } else if(value == 'Clarity') {
      if(this.props.diamonds.source === 'online') {
        sortParam = 'clarity';
      } else if(this.props.diamonds.source === 'rapnet') {
        sortParam = 'Clarity';
      } else {
        sortParam = 'clarity';
      }
    } else if(value == 'Location') {
      sortParam = 'location_name';
    } else if(value == null) {
      sortParam = '';
    }

    let sortObj = {};
    if(this.props.diamonds.source === 'rapnet') {
      sortObj = {
        sort_by: sortParam,
        sort_direction: 'Asc',
        locations: this.state.locations,
      };
    } else {
      sortObj = {
        sort: sortParam,
        locations: this.state.locations,
      };
    }

    let newFilter = Object.assign({}, this.props.diamonds.diamondFilter, sortObj);

    this.props.setDiamondFilters(newFilter);

    if(currentSort != sortParam) {
      this.resetSearch();
    }
  }

  addLocations() {
    
    let currentLocation = this.props.diamonds.diamondFilter.location;

    if(!currentLocation) {
      currentLocation = 'All';
    }

    let newFilter = Object.assign({}, this.props.diamonds.diamondFilter, {
      locations: this.state.locations,
    });

    this.props.setDiamondFilters(newFilter);

    // if(currentLocation != location_id) {
    this.resetSearch();
    // }
  }

  uncheckAll() {
    this.setState({ selectedDiamonds: [] }, () => {
      this.props.diamondsSaveSelected(this.state.selectedDiamonds);
    });
  }

  toggleSortByMenu() {
    this.setState({ sortByOpen: !this.state.sortByOpen });
  }

  toggleSortByExtensionMenu() {
    this.setState({ sortByExtensionOpen: !this.state.sortByExtensionOpen }); 
  }

  toggleSortArrow() {
    if(this.state.sortByDisplay == 'Location') {
      this.setState({ sortByExtensionOpen: !this.state.sortByExtensionOpen }); 
    } else {
      this.setState({ sortByOpen: !this.state.sortByOpen });
    }
  }

  toggleActionsMenu() {
    this.setState({ actionsOpen: !this.state.actionsOpen });
  }

  selectSort(displayValue) {

    let currentSort = this.state.sortByDisplay;

    if(displayValue == 'Location') {
      this.setState({
        sortByExtensionOpen: true,
      });
      return;
    }

    if(this.state.sortByDisplay != displayValue) {
      this.setState({ sortByDisplay: displayValue }, () => {
        this.addSort(displayValue);
      });
    } else {

      // Do nothing; a sort value will always be selected
      // this.setState({ sortByDisplay: null }, () => {
        // this.addSort('');
      // });
    }

    if(displayValue != 'Location') {
      this.setState({ sortByExtensionDisplay: null });
    }
  }

  getDefaultImage(diamond) {
    switch (diamond.shape) {
      case 'ROUNDS':
        return '/img/diamonds/shapes/round.svg';
      case 'OVALS':
        return '/img/diamonds/shapes/oval.svg';
      case 'EMERALD':
        return '/img/diamonds/shapes/emerald.svg';
      case 'PEAR SHAPE':
        return '/img/diamonds/shapes/pear.svg';
      case 'CUSHION':
        return '/img/diamonds/shapes/cushion.svg';
      case 'SQUARE OR PRINCESS':
        return '/img/diamonds/shapes/princess.svg';
      case 'RADIANT':
        return '/img/diamonds/shapes/radiant.svg';
      case 'MARQUISE':
        return '/img/diamonds/shapes/marquise.svg';
      case 'ASCHER':
        return '/img/diamonds/shapes/asscher.svg';
      case 'HEART SHAPE':
        return '/img/diamonds/shapes/heart.svg';
      case "L'AMOUR CUT":
        return '/img/diamonds/shapes/lamour.svg';
      case 'DAUSSI CUSHION':
        return '/img/diamonds/shapes/daussi.svg';
      default:
        return '/img/diamonds/shapes/round.svg';
    }
  }

	cloneArray(source) {
    let result = [];
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  userNav(page) {
    history.push('/' + page);
  }

  diamondsNav() {
    this.props.setDiamondFilters({});
    history.push('/diamonds');
  }

  editNav() {
    history.push('/diamonds');
  }

  toggleSelected(diamond) {

    let clone = this.cloneArray(this.state.selectedDiamonds);
    let i = this.state.selectedDiamonds.indexOf(diamond.id);
    if(i > -1) {
      clone.splice(i, 1);
    } else {
      clone.push(diamond.id);
    }

    this.setState({
      selectedDiamonds: clone,
    }, () => {
      this.props.diamondsSaveSelected(this.state.selectedDiamonds);
    });
  }

  isSelected(diamond) {
    return this.state.selectedDiamonds.indexOf(diamond.id) > -1;
  }

  toggleIndividualShare(diamond) {

    let clone = this.cloneArray(this.state.expandedIndividualShares);
    let i = this.state.expandedIndividualShares.indexOf(diamond.id);
    if(i > -1) {
      clone.splice(i, 1);
    } else {
      clone.push(diamond.id);
    }

    this.setState({
      expandedIndividualShares: clone,
    });
  }

  individualShareOpen(diamond) {
    return this.state.expandedIndividualShares.indexOf(diamond.id) > -1;
  }

  toggleShowOnlySelected() {
    this.setState({ showOnlySelected: !this.state.showOnlySelected });
  }

  getCost(diamond) {
    if(!isLoggedIn() || diamond.cost === null || diamond.cost === 0) {
      return '';
    } else {
      if(this.props.auth.hideData) {
        return '';
      } else {
        return '(' + formatCost(diamond) + ')';
      }
    }
  }

  resetFilters() {
    this.setState({
      sortByOpen: false,
      sortByDisplay: this.props.diamonds.source === 'store' ? 'Purple' : 'Price',
      sortByValue: null,
      sortByExtensionOpen: false,
      sortByExtensionDisplay: null,
      sortByExtensionValue: null,
      actionsOpen: false,
    }, () => {
      let newFilter = Object.assign({}, this.props.diamonds.diamondFilter, {
        sort: 'price',
        location: '',
      });
      this.props.setDiamondFilters(newFilter);
      this.resetSearch();
    })
  }

  shareDiamond(diamond) {
    if(isLoggedIn()) {
      this.setState({
        selectedDiamonds: [ diamond.id ],
      }, () => {
        this.props.diamondsSaveSelected(this.state.selectedDiamonds);
        this.props.leadsOpenShareDirectDropdown([diamond]);
      });
    }
  }

  holdAll() {

    if(this.state.selectedDiamonds.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }
    this.setState({ holdModalOpen: true });
  }

  sendHoldRequest() {
    let confirmationMessage = 'Hold requests sent';
    if(this.state.selectedDiamonds.length === 1) {
      confirmationMessage = 'Hold request sent';
    }
    this.props.messagesShowConfirmation(confirmationMessage);
    this.setState({
      holdModalOpen: false,
    }, () => {

      let holdData = {
        diamonds: this.state.selectedDiamonds,
        message_body: this.state.holdMessage,
      }

      this.props.messagesSendHoldReq(holdData)
      .then((respData) => {
        this.uncheckAll();
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    });
  }

  transferAll() {

    if(this.state.selectedDiamonds.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }
    this.setState({ transferModalOpen: true });
  }

  validateTransfer() {
    if(!this.state.transferApptDate) {
      this.setState({
        transferApptDateError: 'Please enter an appointment date',
      });
      return false;
    }
    return true;
  }

  sendTransferRequest() {

    if(this.validateTransfer() === false) {
      return null;
    }

    let confirmationMessage = 'Transfer requests sent';
    if(this.state.selectedDiamonds.length === 1) {
      confirmationMessage = 'Transfer request sent';
    }
    this.props.messagesShowConfirmation(confirmationMessage);
    this.setState({
      transferModalOpen: false,
    }, () => {

      let transferData = {
        diamonds: this.state.selectedDiamonds,
        message_body: this.composeTransferMessage(),
        appointment_date: this.state.transferApptDate,
      }

      this.props.messagesSendTransferReq(transferData)
      .then((respData) => {
        this.uncheckAll();
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    });
  }

  shareAll() {
    
    if(this.state.selectedDiamonds.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }

    // Make list of diamond objects
    let diamonds = [];
    for(let i = 0; i < this.state.selectedDiamonds.length; i++) {
      for(let j = 0; j < this.props.diamonds.diamondResults.length; j++) {
        if(this.props.diamonds.diamondResults[j].id === this.state.selectedDiamonds[i]) {
          diamonds.push(this.props.diamonds.diamondResults[j]);
          break;
        }
      }
    }
    this.props.leadsOpenShareDirectDropdown(diamonds);
  }

  addToCustomerCard() {
    if(this.state.selectedDiamonds.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }

    // Make list of diamond objects
    let diamonds = [];
    for(let i = 0; i < this.state.selectedDiamonds.length; i++) {
      for(let j = 0; j < this.props.diamonds.diamondResults.length; j++) {
        if(this.props.diamonds.diamondResults[j].id === this.state.selectedDiamonds[i]) {
          diamonds.push(this.props.diamonds.diamondResults[j]);
          break;
        }
      }
    }
    this.props.leadsOpenAddDropdown(diamonds);
  }

  addToExternalProfile() {

    if(this.state.selectedDiamonds.length === 0) {
      this.props.commonAlert('Please select at least one diamond');
      return;
    }
    
    if(this.props.users.customerCard === null) {

      // Make list of diamond objects
      let diamonds = [];
      for(let i = 0; i < this.state.selectedDiamonds.length; i++) {
        for(let j = 0; j < this.props.diamonds.diamondResults.length; j++) {
          if(this.props.diamonds.diamondResults[j].id === this.state.selectedDiamonds[i]) {
            diamonds.push(this.props.diamonds.diamondResults[j]);
            break;
          }
        }
      }

      this.props.usersAddToShareQueue(diamonds, window.location.pathname);
      this.userNav('customer-profile');
    } else {

      let addData = {
        card_id: this.props.users.customerCard.id,
        diamonds: this.state.selectedDiamonds,
      }

      this.props.leadsAddDiamonds(addData)
      .then((respData) => {
        this.props.commonAlert('Diamonds added to your profile');
        this.setState({
          selectedDiamonds: [],
        }, () => {
          this.props.diamondsSaveSelected(this.state.selectedDiamonds);
        });
      })
      // .catch((errorResp) => {
      //   // console.error(errorResp);
      // });
    }
  }

  externalShareAll(diamonds) {
    if(this.props.users.customerCard === null) {
      this.props.usersAddToShareQueue(diamonds, window.location.pathname);
      this.userNav('customer-profile');
    } else {
      this.setState({ shareAllOpen: true });
    }
  }

  getShareCardId() {
    return this.props.users.customerCard ? this.props.users.customerCard.lookup_key : '';
  }

  getShareCardEmail() {
    return this.props.users.customerCard ? this.props.users.customerCard.email : '';
  }

  setLocations(location) {

    location = location.toString();

    if(location === 'All') {
      this.setState({ 
        locations: 'All', 
        sortByExtensionOpen: false,
      }, () => {
        this.addLocations();
      });
      return;
    }
    if(this.state.locations.toString().indexOf('All') > -1) {
      this.setState({ locations: location.toString() }, () => {
        this.addLocations();
      });
      return;
    }

    let clone = this.state.locations.toString().split(',');
    if(clone[0] === '') {
      clone = [];
    }

    let i = clone.indexOf(location);
    if(i === -1) {
      clone.push(location);
      this.setState({ locations: clone.join(',') }, () => {
        this.addLocations();
        return;
      });
    } else {
      clone.splice(i, 1);
      if(clone.length === 0) {
        this.setState({ locations: 'All' }, () => {
          this.addLocations();
          return;
        });
      } else {
        this.setState({ locations: clone.join(',') }, () => {
          this.addLocations();
          return;
        });
      }
    }
  }

  isOnHold(diamond) {
    if(diamond.last_hold === null) {
      return false;
    }
    let holdTime = new Date(diamond.last_hold);
    let now = new Date();

    if((now - holdTime) <= holdConst.HOLD_DURATION) {
      return true;
    }
    return false;
  }

  changeTransferName(evt) {
    this.setState({ transferName: evt.target.value });
  }

  changeTransferApptDate(evt) {
    this.setState({ transferApptDate: evt.target.value });
  }

  changeTransferApptTime(evt) {
    this.setState({ transferApptTime: evt.target.value });
  }

  changeTransferBudget(evt) {
    this.setState({ transferBudget: evt.target.value });
  }

  changeTransferMessage(evt) {
    this.setState({ transferMessage: evt.target.value });
  }

  changeHoldMessage(evt) {
    this.setState({
      holdMessage: evt.target.value,
    });
  }

  closeTransferModal() {
    this.setState({ transferModalOpen: false });
  }

  closeHoldModal() {
    this.setState({ holdModalOpen: false });
  }

  composeTransferMessage() {
    let baseMessage = '';
    if(this.state.transferName !== '') {
      baseMessage = baseMessage + 'Customer name: ' + this.state.transferName + '\n';
    }
    if(this.state.transferApptDate !== '') {
      baseMessage = baseMessage + 'Appointment Date: ' + this.state.transferApptDate + '\n';
    }
    if(this.state.transferApptTime !== '') {
      baseMessage = baseMessage + 'Appointment Time: ' + this.state.transferApptTime + '\n';
    }
    if(this.state.transferBudget !== '') {
      baseMessage = baseMessage + 'Budget: ' + this.state.transferBudget + '\n';
    }
    if(this.state.transferMessage !== '') {
      baseMessage = baseMessage + 'Message: ' + this.state.transferMessage;
    }
    return baseMessage;
  }

  openShareInternal() {

    // Make list of diamond objects
    let diamonds = [];
    for(let i = 0; i < this.state.selectedDiamonds.length; i++) {
      for(let j = 0; j < this.props.diamonds.diamondResults.length; j++) {
        if(this.props.diamonds.diamondResults[j].id === this.state.selectedDiamonds[i]) {
          diamonds.push(this.props.diamonds.diamondResults[j]);
          break;
        }
      }
    }
    this.props.messagesOpenNewDiamondDropdown(diamonds);
    this.setState({ shareModalOpen: false });
  }

  // Depricated; no longer called
  openShareExternal() {

    // Make list of diamond objects
    let diamonds = [];
    for(let i = 0; i < this.state.selectedDiamonds.length; i++) {
      for(let j = 0; j < this.props.diamonds.diamondResults.length; j++) {
        if(this.props.diamonds.diamondResults[j].id === this.state.selectedDiamonds[i]) {
          diamonds.push(this.props.diamonds.diamondResults[j]);
          break;
        }
      }
    }
    this.props.leadsOpenShareDirectDropdown(diamonds);
  }

  closeShareModal() {
    this.setState({ shareModalOpen: false });
  }

  addIndividualDiamondToCard(diamond) {

    if(this.props.users.customerCard === null) {
      return;
    }

    let addData = {
      card_id: this.props.users.customerCard.id,
      diamonds: [ diamond.id ],
    }

    this.props.leadsAddDiamonds(addData)
    .then((respData) => {
      // Do nothing
    })
    // .catch((errorResp) => {
    //   // console.error(errorResp);
    // });
  }

  addMultipleDiamondsToCard() {

    if(this.props.users.customerCard === null) {
      return;
    }

    let addData = {
      card_id: this.props.users.customerCard.id,
      diamonds: this.state.selectedDiamonds,
    }

    this.props.leadsAddDiamonds(addData)
    .then((respData) => {

    })
    // .catch((errorResp) => {
    //   // console.error(errorResp);
    // });
  }

  getLocationCount(locationName) {

    let targetId = getLocationId(locationName);
    let isAll = locationName == 'All';

    if(!this.state.locationData) {
      return '';
    }

    let allCount = 0;
    for(let i = 0; i < this.state.locationData.length; i++) {
      if(this.state.locationData[i].location_num == targetId) {
        return '(' + this.state.locationData[i].count + ')';
      }
      if(isAll) {
        allCount += this.state.locationData[i].count;
      }
    }
    
    if(isAll) {
      return '(' + allCount + ')';
    }

    return '';
  }

  isLocationSelected(locationName) {

    let locationArray = this.state.locations.toString().split(',');
    if(locationArray[0] === '') {
      locationArray = [];
    }
    return locationArray.indexOf(getLocationId(locationName).toString()) > -1;
  }

  viewDiamond(diamond) {
    this.props.diamondsSetLastPosition(this.props.common.currentScrollTop);

    if(this.isOnlineDiamond()) {
      this.userNav('diamond/online/' + diamond.id);
    } else if(this.isRapnetDiamond()) {
      this.userNav('diamond/rapnet/' + diamond.id);
    } else if(this.isLabDiamond()) {
      this.userNav('diamond/lcd/' + diamond.id);
    } else {
      this.userNav('diamond/view/' + diamond.id);
    }
  }

  shouldAllowShare() {
    return this.props.diamonds.source === 'store';
  }

  hasLocationValue() {
    return this.props.diamonds.source === 'store';
  }

  hasCaseLocationValue() {
    return this.props.diamonds.source === 'store';
  }

  isAscDiamond() {
    return this.props.diamonds.source === 'store';
  }

  isOnlineDiamond() {
    return this.props.diamonds.source === 'online';
  }

  isRapnetDiamond() {
    return this.props.diamonds.source === 'rapnet';
  }

  isLabDiamond() {
    return this.props.diamonds.source === 'lab';
  }

  getDiamondImageUrl(diamond) {

    if(!diamond && (!diamond.image || !diamond.laying_ref_code)) { return ''; }

    if(diamond.laying_ref_code) {
      return 'https://segoma.com/ws/public/GetPhoto/first/3/' + diamond.laying_ref_code;
    } else {
      if(diamond.image.substring(0, 4) === 'http' || diamond.image.substring(0, 2) === '//') {
        return diamond.image;
      }
      return 'https://s3.amazonaws.com/inv-app-diamond-unprocessed-prod/' + diamond.image;
    }
    return '';
  }

  getSpecialDiamondClasses(diamond) {
    if(!diamond) { return '' ; }

    // The diamond.sub_class check is redundant, but we're just making sure it's backwards compatible
    if(diamond.is_pdd || diamond.sub_class === 'SPF') {
      return 'classSPF';
    }
    return '';
  }

	render() {

    // let base_url = window.location.protocol + '//' + location.hostname;
    let base_url = api.FRONTEND_URL;

		return <div className={isLoggedIn() ? 'Results loggedIn' : 'Results'}>
      <DiamondSourceBannerContainer showTabs={false} />
      <div className='resultsHeaderSpacer withBanner'></div>
      <div className={isLoggedIn() ? 'resultsHeader withBanner loggedInHeader' : 'resultsHeader withBanner'}>
        <div className='resultsHeaderWrapper'>Diamond Results</div>
        

        <div className={isLoggedIn() ? 'controlsWrapper loggedIn' : 'controlsWrapper'}>
          <div className='lhsControls'>
            <div className='sortByWrapper'>
              <div 
                className='sortByLabel' 
                onClick={this.toggleSortByMenu.bind(this)} 
                ref={(sortByLabel) => { this.sortByLabel = sortByLabel; }}>
                Sort By:
                <div className={this.state.sortByOpen ? 'sortByMenu resultsMenu open' :  'sortByMenu resultsMenu'} ref={(sortByMenuBody) => { this.sortByMenuBody = sortByMenuBody; }}>
                  <div className='menuInnerWrapper'>
                    {this.props.diamonds.source === 'store' && (
                      <div 
                        className={this.state.sortByDisplay == 'Purple' ?  'menuEntry selected' : 'menuEntry'} 
                        onClick={() => this.selectSort('Purple')}>
                        <div className='selectCheck'><i className="fas fa-check"></i></div>Purple Diamonds
                      </div>
                    )}
                    <div 
                      className={this.state.sortByDisplay == 'Price' ?  'menuEntry selected' : 'menuEntry'} 
                      onClick={() => this.selectSort('Price')}>
                      <div className='selectCheck'><i className="fas fa-check"></i></div>Price
                    </div>
                    {isLoggedIn() && this.props.diamonds.source === 'store' ?
                      <div 
                        className={this.state.sortByDisplay == 'Cost' ?  'menuEntry selected' : 'menuEntry'} 
                        onClick={() => this.selectSort('Cost')}>
                        <div className='selectCheck'><i className="fas fa-check"></i></div>Cost
                      </div> :
                      null
                    }
                    <div 
                      className={this.state.sortByDisplay == 'Carat' ?  'menuEntry selected' : 'menuEntry'} 
                      onClick={() => this.selectSort('Carat')}>
                      <div className='selectCheck'><i className="fas fa-check"></i></div>Carat
                    </div>
                    <div 
                      className={this.state.sortByDisplay == 'Color' ?  'menuEntry selected' : 'menuEntry'} 
                      onClick={() => this.selectSort('Color')}>
                      <div className='selectCheck'><i className="fas fa-check"></i></div>Color
                    </div>
                    <div 
                      className={this.state.sortByDisplay == 'Clarity' ?  'menuEntry selected' : 'menuEntry'} 
                      onClick={() => this.selectSort('Clarity')}>
                      <div className='selectCheck'><i className="fas fa-check"></i></div>Clarity
                    </div>
                    <div 
                      className={this.state.sortByDisplay == 'Location' ?  'menuEntry selected' : 'menuEntry'} 
                      onClick={() => this.selectSort('Location')}
                      style={this.props.diamonds.source !== 'store' ? { display: 'none' } : {}}>
                      <div className='selectCheck'><i className="fas fa-check"></i></div>Location
                    </div>
                  </div>
                </div>
              </div>
              {this.state.sortByDisplay ?
                <div 
                  className='sortByDisplay' 
                  onClick={this.toggleSortByMenu.bind(this)} 
                  ref={(sortByDisplay) => { this.sortByDisplay = sortByDisplay; }}>{this.state.sortByDisplay}</div> :
                null
              }
              <div 
                className='sortByArrow' 
                onClick={this.toggleSortArrow.bind(this)} 
                ref={(sortByArrow) => { this.sortByArrow = sortByArrow; }}>
                <img src='/img/results/arrow.svg' />
              </div>
              {this.state.sortByDisplay == 'Location' || true ?
                <div 
                  className='sortByExtensionDisplay' 
                  ref={(sortByExtensionDisplay) => { this.sortByExtensionDisplay = sortByExtensionDisplay; }}
                  style={this.props.diamonds.source !== 'store' ? { display: 'none' } : {}}>
                  {this.state.sortByExtensionDisplay ? 
                    this.state.sortByExtensionDisplay : 
                    <span onClick={this.toggleSortByExtensionMenu.bind(this)}>
                      {this.state.locations == 'All' ?
                        <span>All&nbsp;Locations</span> :
                        <span>Select&nbsp;Locations</span>
                      }
                    </span>
                  }
                  <div className={this.state.sortByExtensionOpen ? 'sortBySecondaryMenu resultsMenu open' : 'sortBySecondaryMenu resultsMenu'} ref={(sortByExtensionMenuBody) => { this.sortByExtensionMenuBody = sortByExtensionMenuBody; }}>
                    <div className='menuInnerWrapper'>
                      <div 
                        className={'menuEntry'}
                        onClick={this.toggleSortByExtensionMenu.bind(this)}>
                        <div className='selectClose'>&times;</div>
                        Close&nbsp;Locations
                      </div>
                      <div className='inlineLocations'>
                        <div 
                          className={this.state.locations.toString().split(',').indexOf('All') > -1 ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations('All')}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          All&nbsp;Locations<span className='locationCount'>{this.getLocationCount('All')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Atlanta') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Atlanta'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Atlanta<span className='locationCount'>{this.getLocationCount('Atlanta')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Austin') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Austin'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Austin<span className='locationCount'>{this.getLocationCount('Austin')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Aventura') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Aventura'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Aventura<span className='locationCount'>{this.getLocationCount('Aventura')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Baybrook') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Baybrook'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Baybrook<span className='locationCount'>{this.getLocationCount('Baybrook')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Birmingham') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Birmingham'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Birmingham<span className='locationCount'>{this.getLocationCount('Birmingham')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Boca Raton') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Boca Raton'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Boca Raton<span className='locationCount'>{this.getLocationCount('Boca Raton')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Charleston') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Charleston'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Charleston<span className='locationCount'>{this.getLocationCount('Charleston')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Charlotte') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Charlotte'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Charlotte<span className='locationCount'>{this.getLocationCount('Charlotte')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Cleveland') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Cleveland'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Cleveland<span className='locationCount'>{this.getLocationCount('Cleveland')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Columbus') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Columbus'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Columbus<span className='locationCount'>{this.getLocationCount('Columbus')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Dallas') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Dallas'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Dallas<span className='locationCount'>{this.getLocationCount('Dallas')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Fort Worth') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Fort Worth'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Fort Worth<span className='locationCount'>{this.getLocationCount('Fort Worth')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Frisco') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Frisco'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Frisco<span className='locationCount'>{this.getLocationCount('Frisco')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Greenville') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Greenville'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Greenville<span className='locationCount'>{this.getLocationCount('Greenville')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Houston') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Houston'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Houston<span className='locationCount'>{this.getLocationCount('Houston')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Indianapolis') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Indianapolis'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Indianapolis<span className='locationCount'>{this.getLocationCount('Indianapolis')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Jacksonville') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Jacksonville'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Jacksonville<span className='locationCount'>{this.getLocationCount('Jacksonville')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Kansas City') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Kansas City'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Kansas&nbsp;City<span className='locationCount'>{this.getLocationCount('Kansas City')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Milwaukee') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Milwaukee'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Milwaukee<span className='locationCount'>{this.getLocationCount('Milwaukee')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('New Orleans') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('New Orleans'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          New Orleans<span className='locationCount'>{this.getLocationCount('New Orleans')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Oakbrook') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Oakbrook'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Oakbrook<span className='locationCount'>{this.getLocationCount('Oakbrook')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Oklahoma City') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Oklahoma City'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Oklahoma&nbsp;City<span className='locationCount'>{this.getLocationCount('Oklahoma City')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Orlando') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Orlando'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Orlando<span className='locationCount'>{this.getLocationCount('Orlando')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Palm Beach') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Palm Beach'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Palm Beach<span className='locationCount'>{this.getLocationCount('Palm Beach')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Pittsburgh') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Pittsburgh'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Pittsburgh<span className='locationCount'>{this.getLocationCount('Pittsburgh')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Raleigh') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Raleigh'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Raleigh<span className='locationCount'>{this.getLocationCount('Raleigh')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Richmond') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Richmond'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Richmond<span className='locationCount'>{this.getLocationCount('Richmond')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Rockville') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Rockville'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Rockville<span className='locationCount'>{this.getLocationCount('Rockville')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('St. Louis') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('St. Louis'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          St.&nbsp;Louis<span className='locationCount'>{this.getLocationCount('St. Louis')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('San Antonio') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('San Antonio'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          San&nbsp;Antonio<span className='locationCount'>{this.getLocationCount('San Antonio')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Schaumburg') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Schaumburg'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Schaumburg<span className='locationCount'>{this.getLocationCount('Schaumburg')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Troy') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Troy'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Troy<span className='locationCount'>{this.getLocationCount('Troy')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Tysons') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Tysons'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Tysons<span className='locationCount'>{this.getLocationCount('Tysons')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Virginia Beach') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Virginia Beach'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Virginia&nbsp;Beach<span className='locationCount'>{this.getLocationCount('Virginia Beach')}</span>
                        </div>
                        <div 
                          className={this.isLocationSelected('Woodlands') ? 'menuEntry inlineEntry selected' : 'menuEntry inlineEntry'}
                          onClick={() => this.setLocations(getLocationId('Woodlands'))}>
                          <div className='selectCheck'><i className="fas fa-check"></i></div>
                          Woodlands<span className='locationCount'>{this.getLocationCount('Woodlands')}</span>
                        </div>
                      </div>
                      <div 
                        className={'menuEntry'}
                        onClick={this.toggleSortByExtensionMenu.bind(this)}
                        style={{paddingBottom: '45px'}}>
                        <div className='selectClose'>&times;</div>
                        Close&nbsp;Locations
                      </div>
                    </div>
                  </div>
                </div> :
                null
              }
              
              <div className='resetFilters' onClick={this.resetFilters.bind(this)}>Reset</div>
            </div>
          </div>
          <div className='rhsControls'>
            <div className='actionsWrapper'>
              
              <div className='actionsArrow' onClick={this.toggleActionsMenu.bind(this)} ref={(actionsArrow) => { this.actionsArrow = actionsArrow; }}>
                <img src='/img/results/arrow.svg' />
                <div className={this.state.actionsOpen ? 'actionsMenu resultsMenu open' : 'actionsMenu resultsMenu'} ref={(actionsMenuBody) => { this.actionsMenuBody = actionsMenuBody; }}>
                  <div className='menuInnerWrapper'>
                    <div 
                      className={this.state.showOnlySelected ? 'menuEntry selected' : 'menuEntry'} 
                      onClick={this.toggleShowOnlySelected.bind(this)}>
                      <div className='selectCheck'><i className="fas fa-check"></i></div>Show&nbsp;Only&nbsp;Selected</div>
                    {isLoggedIn() ?
                      <div style={this.props.diamonds.source !== 'store' ? { display: 'none' } : {}}>
                        <div className='menuEntry' onClick={this.transferAll.bind(this)}>Transfer&nbsp;All</div>
                        <div className='menuEntry' onClick={this.holdAll.bind(this)}>Hold&nbsp;All</div>
                        {isGM() || isSA() ?
                          <div className='menuEntry' onClick={this.addToCustomerCard.bind(this)}>Add&nbsp;to&nbsp;Customer&nbsp;Card</div> :
                          null
                        }
                      </div> :
                      <div className='menuEntry' onClick={this.addToExternalProfile.bind(this)} style={this.props.diamonds.source !== 'store' ? { display: 'none' } : {}}>Add&nbsp;to&nbsp;My&nbsp;Profile</div>
                    }
                    <div className='menuEntry' onClick={this.shareAll.bind(this)} style={this.props.diamonds.source !== 'store' ? { display: 'none' } : {}}>Share&nbsp;All</div>
                    <div className='menuEntry' onClick={this.uncheckAll.bind(this)}>Uncheck&nbsp;All</div>
                  </div>
                </div>
              </div>
              <div className='actionsLabel' onClick={this.toggleActionsMenu.bind(this)} ref={(actionsLabel) => { this.actionsLabel = actionsLabel; }}>Actions</div>
              <div className='editSearchHeaderWrapper' onClick={this.editNav.bind(this)}>
                Edit Search
              </div>
            </div>
          </div>
          <div className='centerToggle' onClick={this.props.diamondsToggleListView.bind(this)}>
            {this.props.diamonds.resultsList ?
              <div>Show detail view</div> :
              <div>Show list view</div>
            }
          </div>
        </div>




      </div>
      {this.state.resultsBlocked ?
        <div className='loginPrompt'>Please <span className='loginLink' onClick={() => this.userNav('login')}>login</span> to see results</div> :
        <div>
          

          <div className='shareAllBlock' style={{maxHeight: this.state.shareAllOpen ? '200px' : '0'}}>
            <div className='shareAllWrapper'>
              <div className='shareAllTitle'>Share All</div>
              <div className='shareAllIconWrapper' onClick={this.addMultipleDiamondsToCard.bind(this)}>
                <a href={'mailto:' + this.getShareCardEmail() + '?subject=' + encodeURIComponent('My diamond collection') + '&body=' + encodeURIComponent('Check out the diamond collection I have shared! ' + base_url + '/shared-collection/' + this.getShareCardId())}>
                  <div className='shareIcon'>
                    <img src='/img/icons/share/email.svg' />
                  </div>
                </a>
                <a href={'https://www.facebook.com/sharer/sharer.php?u=' + base_url + '/shared-collection/' + this.getShareCardId()} target="_blank" style={{display: 'none'}}>
                  <div className='shareIcon'>
                    <img src='/img/icons/share/facebook.svg' />
                  </div>
                </a>
                <a href={'https://api.whatsapp.com/send?text=' + encodeURIComponent('Check out the diamond collection I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())} target="_blank">
                  <div className='shareIcon'>
                    <img src='/img/icons/share/whatsapp.svg' />
                  </div>
                </a>
                <a href={'sms:?body=' + encodeURIComponent('Check out the diamond collection I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())}>
                  <div className='shareIcon'>
                    <img src='/img/icons/share/text.svg' />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className={this.props.diamonds.resultsList ? 'resultsWrapper listView' : 'resultsWrapper blockView'} ref={(div) => { this.resultsWrapper = div; }}>
            {this.props.diamonds.diamondResults == null ?
              <div className='loadingDiamonds'>
                <RhinoLoading message='Loading diamonds' />
              </div> :
              <div>
                {this.props.diamonds.diamondResultsCount === 1 ?
                  <div className='foundLabel'>{'Found ' + this.props.diamonds.diamondResultsCount + ' diamond'}</div> :
                  <div className='foundLabel'>{'Found ' + formatNumber(this.props.diamonds.diamondResultsCount) + ' diamonds'}</div>
                }
                <div className='editSearchWrapper' onClick={this.editNav.bind(this)}>
                  Edit Search
                </div>
                {this.props.diamonds.diamondResults.length === 0 ?
                  <div className='nullResults'>
                    No diamonds matching your search parameters
                  </div> :
                  <div>
                    {this.props.diamonds.resultsList && this.state.windowWidth > 1024 ?
                      <div className='listViewWrapper'>
                        <div className='listViewHeader listDiamondEntry'>
                          <div className='selectCell headerCell'></div>
                          <div className='skuCell headerCell'>SKU</div>
                          <div className='descriptionCell headerCell'>Description</div>
                          <div className='priceCell headerCell'>Price</div>
                          {this.hasLocationValue() ?
                            <div className='locationCell headerCell'>Location</div> :
                            null
                          }
                          <div className='labCell headerCell'>Lab</div>
                          <div className='typeCell headerCell'>Type</div>
                          <div className='sizeCell headerCell'>Size</div>
                          <div className='symCell headerCell'>Sym</div>
                          <div className='cutCell headerCell'>Cut</div>
                          <div className='flCell headerCell'>Fluor.</div>
                          <div className='tableCell headerCell'>Table</div>
                          <div className='depthCell headerCell'>Depth</div>
                          {this.hasCaseLocationValue() ?
                            <div className='caseCell headerCell'>Case Location</div> :
                            null
                          }
                          <div className='actionCell headerCell'>Action</div>
                        </div>
                        <div className='listViewBody'>
                          {this.props.diamonds.diamondResults.map((diamond, i) => {

                            if(this.state.showOnlySelected && !this.isSelected(diamond)) {
                              return null;
                            }

                            return <div className={this.isSelected(diamond) ? 'listDiamondEntry selected' : 'listDiamondEntry'} key={i}>
                              <div className='selectCell entryCell'>
                                <div className={this.isSelected(diamond) ? 'favoriteWrapper favoriteSelected' : 'favoriteWrapper'} onClick={() => this.toggleSelected(diamond)}>
                                  <img src='/img/diamonds/star.svg' className='notSelectedStar' />
                                  <img src='/img/diamonds/star_fill.svg' className='selectedStar' />
                                </div>
                              </div>
                              <div className='skuCell entryCell' onClick={() => this.viewDiamond(diamond)}>{this.props.diamonds.source == 'online' ? diamond.id : diamond.web_item}</div>
                              <div className='descriptionCell entryCell' onClick={() => this.viewDiamond(diamond)}>{formatDiamondTitle(diamond)}</div>
                              <div className={this.props.diamonds.source === 'rapnet' ? 'priceCell rapnetPrice entryCell' : 'priceCell entryCell'} onClick={() => this.viewDiamond(diamond)}>{formatPrice(diamond)}<span className={this.props.auth.hideData || this.props.diamonds.source === 'rapnet' ? 'costWrapper costHidden' : 'costWrapper'}>{this.getCost(diamond)}</span></div>
                              {this.hasLocationValue() ?
                                <div className='locationCell entryCell' onClick={() => this.viewDiamond(diamond)}>{formatLocation(diamond)}</div> :
                                null
                              }
                              <div className='labCell entryCell' onClick={() => this.viewDiamond(diamond)}>
                                {diamond.lab}
                                {diamond.lab == 'GIA' && diamond.gia_number ?
                                  <span>{' - ' + diamond.gia_number}</span> :
                                  null
                                }
                              </div>
                              <div className='typeCell entryCell' onClick={() => this.viewDiamond(diamond)}>{diamond.in_wallet ? 'Loose' : 'Mounted'}</div>
                              <div className='sizeCell entryCell' onClick={() => this.viewDiamond(diamond)}>{formatMeasurements(diamond)}</div>
                              <div className='symCell entryCell' onClick={() => this.viewDiamond(diamond)}>{formatSymmetry(diamond)}</div>
                              <div className='cutCell entryCell' onClick={() => this.viewDiamond(diamond)}>{formatCut(diamond)}</div>
                              <div className='flCell entryCell' onClick={() => this.viewDiamond(diamond)}>{formatFluorescence(diamond)}</div>
                              <div className='tableCell entryCell'>{formatTable(diamond)}</div>
                              <div className='depthCell entryCell'>{formatDepth(diamond)}</div>
                              {this.hasCaseLocationValue() ?
                                <div className='caseCell entryCell'>{diamond.case_location ? diamond.case_location : 'Unassigned'}</div> :
                                null
                              }
                              <div className='actionCell entryCell' onClick={() => this.viewDiamond(diamond)}>View</div>
                            </div>;
                          })}
                        </div>
                      </div> :
                      <div className='blockViewWrapper'>
                        {this.props.diamonds.diamondResults.map((diamond, i) => {

                          if(this.state.showOnlySelected && !this.isSelected(diamond)) {
                            return null;
                          }

                          return <div className={`diamondEntry ${this.getSpecialDiamondClasses(diamond)}`} key={i}>
                            <div className={this.isSelected(diamond) ? 'entryInnerWrapper selected' : 'entryInnerWrapper'}>
                              <div className='diamondControlsWrapper'>
                                <div className={this.isSelected(diamond) ? 'favoriteWrapper favoriteSelected' : 'favoriteWrapper'} onClick={() => this.toggleSelected(diamond)}>
                                  <img src='/img/diamonds/star.svg' className='notSelectedStar' />
                                  <img src='/img/diamonds/star_fill.svg' className='selectedStar' />
                                </div>
                              </div>
                              <div className='imageWrapper' onClick={() => this.viewDiamond(diamond)}>
                                {diamond.image || diamond.laying_ref_code ?
                                  <img src={this.getDiamondImageUrl(diamond)} /> :
                                  <img src={this.getDefaultImage(diamond)} />
                                }
                                {isLoggedIn() && this.isOnHold(diamond) ?
                                  <div className='onHoldIndicator'>On Hold</div> :
                                  null
                                }
                              </div>
                              <div className='entryBody'>
                                <div className='entryHeader'>
                                  <div className='headerTitle'>
                                    <div className='titleWrapper'>{formatDiamondTitle(diamond)}</div>
                                    <div className={this.props.diamonds.source === 'rapnet' ? 'priceWrapper rapnetPrice' : 'priceWrapper'}>{formatPrice(diamond)}<span className={this.props.auth.hideData || this.props.diamonds.source === 'rapnet' ? 'costWrapper costHidden' : 'costWrapper'}>{this.getCost(diamond)}</span></div>
                                    <div className='locationWrapper' style={!this.isAscDiamond() ? {display: 'none'} : {}}>
                                      <div className='locationIcon'>
                                        <i className="fas fa-map-marker-alt"></i>
                                      </div>
                                      <div className='locationValue'>
                                        {formatLocation(diamond)}
                                      </div>
                                      {isLoggedIn() && this.isOnHold(diamond) ?
                                        <div className='locationHold'>
                                          On Hold
                                        </div> :
                                        null
                                      }
                                      {isLoggedIn() && !this.isOnHold(diamond) ?
                                        <div className={this.props.auth.hideData || this.props.diamonds.source === 'rapnet' ? 'locationCost costHidden' : 'locationCost'}>
                                          {this.getCost(diamond)}
                                        </div> :
                                        null
                                      }
                                    </div>
                                  </div>
                                  <div className='headerButtons'>
                                    <div className={'viewButton secondaryButton'} onClick={() => this.viewDiamond(diamond)}>View</div>
                                    <div 
                                      className={'shareButton secondaryButton'} 
                                      onClick={() => this.shareDiamond(diamond)}
                                      style={!this.isAscDiamond() ? {display: 'none'} : {}}>
                                      Share
                                    </div>
                                    <div className='shareDrawer' style={{maxHeight: this.individualShareOpen(diamond) ? '150px' : '0'}}>
                                      <div className='shareIconWrapper' onClick={() => this.addIndividualDiamondToCard(diamond)}>
                                        <a href={'mailto:' + this.getShareCardEmail() + '?subject=' + encodeURIComponent('My diamond collection') + '&body=' + encodeURIComponent('Check out the diamond collection I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())}>
                                          <div className='shareIcon'>
                                            <img src='/img/icons/share/email.svg' />
                                          </div>
                                        </a>
                                        <a href={'https://www.facebook.com/sharer/sharer.php?u=' + base_url + '/shared-collection/' + this.getShareCardId()} target="_blank" style={{display: 'none'}}>
                                          <div className='shareIcon'>
                                            <img src='/img/icons/share/facebook.svg' />
                                          </div>
                                        </a>
                                        <a href={'https://api.whatsapp.com/send?text=' + encodeURIComponent('Check out the diamond collection I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())} target="_blank">
                                          <div className='shareIcon'>
                                            <img src='/img/icons/share/whatsapp.svg' />
                                          </div>
                                        </a>
                                        <a href={'sms:?body=' + encodeURIComponent('Check out the diamond collection I have shared!! ' + base_url + '/shared-collection/' + this.getShareCardId())}>
                                          <div className='shareIcon'>
                                            <img src='/img/icons/share/text.svg' />
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='entryDetails'>
                                  <div className='detailsTopLine'>
                                    <div className='skuWrapper'>{this.props.diamonds.source == 'online' ? diamond.id : diamond.web_item}</div>
                                    <div className='verticalSeparator'>|</div>
                                    <div className='measurementsWrapper'>{formatMeasurements(diamond)}</div>
                                    <div className='verticalSeparator' style={!this.isAscDiamond() ? {display: 'none'} : {}}>|</div>
                                    <div className='mountedWrapper' style={!this.isAscDiamond() ? {display: 'none'} : {}}>{diamond.in_wallet ? 'Loose' : 'Mounted'}</div>
                                  </div>
                                  <div className='detailsBody'>
                                    <div className={'detailColumn firstColumn'}>
                                      <div className='detailEntry'>
                                        <div className='detailLabel'>Cut:</div>
                                        <div className='detailValue'>{formatCut(diamond)}</div>
                                      </div>
                                      <div className='detailEntry'>
                                        <div className='detailLabel'>Polish:</div>
                                        <div className='detailValue'>{formatPolish(diamond)}</div>
                                      </div>
                                      <div className='detailEntry'>
                                        <div className='detailLabel'>Table:</div>
                                        <div className='detailValue'>{formatTable(diamond)}</div>
                                      </div>
                                    </div>
                                    <div className={'detailColumn secondColumn'}>
                                      <div className='detailEntry'>
                                        <div className='detailLabel'>Sym:</div>
                                        <div className='detailValue'>{formatSymmetry(diamond)}</div>
                                      </div>
                                      <div className='detailEntry'>
                                        <div className='detailLabel'>Fluor:</div>
                                        <div className='detailValue'>{formatFluorescence(diamond)}</div>
                                      </div>
                                      {(diamond.is_pdd && this.props.auth.hideData === false) && (
                                        <div className='detailEntry purpleEm'>
                                          <div className='detailLabel'>PDD Spiff:</div>
                                          <div className='detailValue'>{formatPddSpiff(diamond)}</div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>;
                        })}
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      {this.props.diamonds.diamondResults !== null ?
        <div>
          <div className={'searchSubmit bottomAction alwaysBottom'} onClick={this.diamondsNav.bind(this)}>
            New Search
          </div>
          <div className='bottomActionSpacer alwaysBottom'></div>
        </div> :
        null
      }
      <RhinoModal
        open={this.state.holdModalOpen}>
        <div className='transferModal'>
        <div className='closeModal' onClick={this.closeHoldModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Hold Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeHoldMessage.bind(this)} 
              value={this.state.holdMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.sendHoldRequest.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.transferModalOpen}>
        <div className='transferModal'>
        <div className='closeModal' onClick={this.closeTransferModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Transfer Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferName.bind(this)}
              value={this.state.transferName}
              placeholder='Customer Name' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              className={this.state.transferApptDateError ? 'error' : ''}
              onChange={this.changeTransferApptDate.bind(this)}
              value={this.state.transferApptDate}
              placeholder='Appointment Date' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferApptTime.bind(this)}
              value={this.state.transferApptTime}
              placeholder='Appointment Time' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferBudget.bind(this)}
              value={this.state.transferBudget}
              placeholder='Estimated Budget' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeTransferMessage.bind(this)} 
              value={this.state.transferMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.sendTransferRequest.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.shareModalOpen && false}>
        <div className='shareModal'>
          <div className='closeModal' onClick={this.closeShareModal.bind(this)}>&times;</div>
          <div className='shareModalTitle'>Who would you like to share with?</div>
          <div className='shareModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='shareModalButtons'>
            <button className={'actionButton shareButton'} onClick={this.openShareInternal.bind(this)}>Employees</button>
            <button className={'actionButton shareButton'} onClick={this.openShareExternal.bind(this)}>Customers</button>
          </div>
        </div>
      </RhinoModal>
    </div>;
	}
}
export default Results;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    common: state.common,
    diamonds: state.diamonds,
    users: state.users,
  };
}

export const ResultsContainer = connect(
  mapStateToProps,
  allActionCreators
)(Results);